import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    inject,
    input,
    output,
} from '@angular/core';
import { TelXLAvatarComponent } from '@dxp/elements';
import { FormatDurationPipe } from '@dxp/core/pipes';
import { Router } from '@angular/router';
import { secondsToDuration } from '@dxp/core/helpers';
import { AvatarVariant, ListingMode } from '@dxp/core/types';
import {
    IDirectoryListing,
    IDirectoryListingSelection,
    IDirectoryListingEvent,
} from '@dxp/core/models';

@Component({
    selector: 'telxl-shared-directory-listing-internal-item',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, TelXLAvatarComponent],
    providers: [FormatDurationPipe],
    templateUrl: './directory-listing-internal-item.component.html',
    styleUrl: './directory-listing-internal-item.component.scss',
})
export class TelXLDirectoryListingInternalItemComponent {
    secondsToDuration = secondsToDuration;

    readonly #router = inject(Router);

    mode = input<ListingMode[]>([]);
    source = input.required<AvatarVariant>();
    item = input.required<IDirectoryListing>();
    selected = input<IDirectoryListingSelection>({
        selected: false,
        item: ['voice'],
    });
    disabled = input<boolean>(false);
    selectedChange = output<IDirectoryListingEvent>();

    select() {
        this.selectedChange.emit({ type: 'custom', item: this.item() });
    }

    action(type: 'mobile' | 'business') {
        if (this.disabled()) return;

        if (this.mode().includes('communicate')) {
            if (
                type === 'mobile' &&
                !this.#router.url.includes('comms/voice')
            ) {
                const number = this.item().mobileNumber;
                if (number) {
                    const encoded = btoa(number);
                    this.#router.navigate(['/comms/voice/new', encoded]);
                }
            }
        }
        if (this.mode().includes('communicate')) {
            if (
                type === 'business' &&
                !this.#router.url.includes('comms/voice')
            ) {
                const number = this.item().businessNumber;
                if (number) {
                    const encoded = btoa(number);
                    this.#router.navigate(['/comms/voice/new', encoded]);
                }
            }
        } else if (this.mode().includes('emit') && type === 'mobile') {
            this.selectedChange.emit({
                type: 'voice',
                item: { ...this.item(), phoneNumber: this.item().mobileNumber },
            });
        } else if (this.mode().includes('emit') && type === 'business') {
            this.selectedChange.emit({
                type: 'voice',
                item: {
                    ...this.item(),
                    phoneNumber: this.item().businessNumber,
                },
            });
        }
    }
}
